import { render, staticRenderFns } from "./TaskListOrder.vue?vue&type=template&id=2237aa79&"
import script from "./TaskListOrder.vue?vue&type=script&lang=js&"
export * from "./TaskListOrder.vue?vue&type=script&lang=js&"
import style0 from "./TaskListOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports